import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_PROCESOS_JURIDICOS
export default class UserSerivce {
  getAll () {
    return http.get(`${baseUrl}/usuarios/all`)
  }
}
